import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

export const TextContainer: React.FC = () => {
	return (
		<div className="flex min-w-62.5 flex-col gap-4">
			<div>
				<Text as="h3" variant="heading" size="small" className="leading-[unset]">
					<Translate value="corgi.membership.awareness.headline_part1" /> — &nbsp;
					<span className="bg-fill-interactive relative z-1 rounded px-1">
						<Translate value="corgi.membership.awareness.headline_part2" />
					</span>
				</Text>
			</div>
			<Translate value="corgi.membership.awareness.description" />
			<Text fontWeight="bold">
				<Translate value="corgi.membership.awareness.ask" />
			</Text>
		</div>
	);
};
